import { FactoryProvider } from "@angular/core";
import { PORTAL_PRODUCT_OVERRIDDEN_LANGUAGES } from "../../constants";
import { PortalOverriddenLanguageModel } from "../../models";
import { LanguageDto } from "gast-common-ng2";

export function providePortalProductOverriddenLanguages(
  overriddenLanguages: PortalOverriddenLanguageModel[] | undefined
): FactoryProvider {
  return {
    provide: PORTAL_PRODUCT_OVERRIDDEN_LANGUAGES,
    useFactory: (): PortalOverriddenLanguageModel[] => {
      if (overriddenLanguages) {
        return overriddenLanguages
          .filter((o: PortalOverriddenLanguageModel) => {
            return o.product && o.languages?.length > 0;
          })
          .map((o: PortalOverriddenLanguageModel): PortalOverriddenLanguageModel => {
            return {
              product: o.product,
              languages: o.languages
                .filter((l: LanguageDto) => {
                  return l.code && l.code.length === 2 && l.name && l.name.length > 0;
                })
                .map((l: LanguageDto): LanguageDto => {
                  return {
                    id: l.id,
                    code: l.code.toUpperCase(),
                    name: l.name,
                  };
                }),
            };
          })
          .filter((o: PortalOverriddenLanguageModel) => {
            return o.languages?.length > 0;
          });
      }
      return [];
    },
  };
}
